import axios from 'axios'

const LogoutService = {
  logoutIframeSession: async () => {
    const logoffUrl = process.env.VUE_APP_IFRAME_FIBER_LOGOUT
    try {
      await axios.get(logoffUrl, { withCredentials: true })
    } catch (error) {
      const errorMessage = `Failed to call logoff URL: ${logoffUrl}. Error: ${error.message || error}`
      //eslint-disable-next-line no-console
      console.error(errorMessage)
    }
  }
}

export default LogoutService
